import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { useNavigate, useLocation } from 'react-router';
import './Navigation.css';

const Navigation = () => {
  const setPage = useNavigate();
  const location = useLocation();

  return (
    <div className="Navbar-wrapper">
      <Navbar className="MPR-navbar" collapseOnSelect expand="lg" bg="primary" variant="dark">
        <Container fluid>
          <Navbar.Brand>2022 ACIC Data Challenge</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav/>
            <Nav 
              defaultActiveKey="/"
              activeKey={location.pathname}
              onSelect={eventKey => setPage(eventKey)}
            >
              <Nav.Item>
                <Nav.Link eventKey="/">Home</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/data">Data</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/estimands">Estimands</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/assumptions">Assumptions</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/submissions">Submissions</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/evaluation">Evaluation</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/results">Results</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="/faq">FAQ</Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}

export default Navigation;
